// 差异管理
import Layout from "@/layout/layout.vue";

const difference = {
  // 加载路径
  path: "/difference",
  // 加载组件
  component: Layout,
  // 重定向路径
  redirect: "noRedirect",
  // 路由名称
  name: "差异管理",
  children: [
    {
      path: "catchUpCategory",
      name: "追差分类管理",
      component: () => import("@/views/difference/catchUpCategory.vue"),
      meta: { title: "追差分类管理", noCache: true }
    },
    {
      path: "platformReview",
      component: () => import("@/views/difference/platformReview/index.vue"),
      name: "平台审核差异单",
      meta: {
        title: "平台审核差异单",
        noCache: true
      }
    },
    {
      path: "platformExtra",
      component: () => import("@/views/difference/platformExtra/index.vue"),
      name: "争议订单额外补差",
      meta: {
        title: "争议订单额外补差",
        noCache: true
      }
    },
    {
      path: "processExtra",
      component: () => import("@/views/difference/platformExtra/process.vue"),
      name: "争议差异订单详情",
      meta: {
        title: "争议差异订单详情",
        noCache: true
      }
    },
    {
      path:"process",
      name:"差异详情",
      component:()=>import("@/views/difference/platformReview/process.vue"),
      meta: {
        title:"差异详情",
        noCache: true
      }
    },
    {
      path:"storeReview",
      name:"门店审核差异单",
      component:()=>import("@/views/difference/storeReview/index.vue"),
      meta: {
        title:"门店审核差异单",
        noCache: true
      }
    },
    {
      path: "honorReview",
      component: () => import("@/views/difference/honorReview/index.vue"),
      name: "闪回追差订单",
      meta: {
        title: "闪回追差订单",
        noCache: true
      }
    },
    {
      path: "caiHuoXiaReview",
      component: () => import("@/views/difference/caiHuoXiaReview/index.vue"),
      name: "采货侠追差订单",
      meta: {
        title: "采货侠追差订单",
        noCache: true
      }
    },
    {
      path: "importRecords",
      component: () => import("@/views/difference/importRecords/index.vue"),
      name: "导入线下打款",
      meta: {
        title: "导入线下打款",
        noCache: true
      }
    },
    {
      path: "externalCatchup",
      component: () => import("@/views/difference/externalCatchup/index.vue"),
      name: "山东追差订单",
      meta: {
        title: "山东追差订单",
        noCache: true
      }
    },
    {
      path: "danghuanReview",
      component: () => import("@/views/difference/danghuanReview/index.vue"),
      name: "当换追差订单",
      meta: {
        title: "当换追差订单",
        noCache: true
      }
    },{
      path: "riskImeiManage",
      component: () => import("@/views/difference/riskImeiManage/index.vue"),
      name: "风险串号管理",
      meta: {
        title: "风险串号管理",
        noCache: true
      }
    },
    {
      path: "outChatGap",
      component: () => import("@/views/difference/outChatGap/index.vue"),
      name: "外部追差类型绑定",
      meta: {
        title: "外部追差类型绑定",
        noCache: true
      }
    },
  ]
}

export default difference;
